module.exports = __webpack_public_path__ + "f8de2315134ff94e4320994a25fbf890.jpg";


//////////////////
// WEBPACK FOOTER
// ./web/images/faces/chicago.jpg
// module id = 596
// module chunks = 0